const ChevronIcon = ({ className, open }) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        transform: open ? "rotate(-180deg)" : "rotate(0deg)",
        transition: "transform 0.9s ease",
      }}
    >
      <path
        d="M 6 8 L 12 14 L 18 8"
        fill="none"
        stroke="#FBAD05"
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronIcon;